import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class VentePriveeService {

    // ===============================
    // Vente Privée CRUD
    // ===============================

    createVp(data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.post(`${api_url}/vente-privee`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: mgToken
            }
        });
    }

    updateVp(id, data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.patch(`${api_url}/vente-privee/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: mgToken
            }
        });
    }

    removeVp(id) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.delete(`${api_url}/vente-privee/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: mgToken
            }
        });
    }

    listVp() {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.get(`${api_url}/vente-privee`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: mgToken
            }
        });
    }

    // ===============================
    // Campaign Source
    // ===============================

    createVpCompagneSource(vpId, data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.post(
            `${api_url}/vente-privee/${vpId}/compagne-source`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    updateVpCompagneSource(id, data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.patch(
            `${api_url}/vente-privee/compagne-source/${id}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    deleteVpCompagneSource(id) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.delete(
            `${api_url}/vente-privee/compagne-source/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    listVpCompagneSource(vpId) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.get(
            `${api_url}/vente-privee/${vpId}/compagne-source`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    // ===============================
    // Prospect
    // ===============================

    createVpProspect(idVp, data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.post(
            `${api_url}/vente-privee/prospect/${idVp}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    updateVpProspect(id, data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.patch(
            `${api_url}/vente-privee/prospect/${id}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    deleteVpProspect(id) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.delete(
            `${api_url}/vente-privee/prospect/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    confirmerVpRdv(id, data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.patch(
            `${api_url}/vente-privee/prospect/${id}/confirmer-rdv`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    getVpProspect(id) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.get(
            `${api_url}/vente-privee/prospect/${id}/view`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }
    sendRdvConfirmarionWsp(id) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.get(
            `${api_url}/vente-privee/prospect/${id}/send-wsp-confirmation`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    updateVpProspectStatus(id, data) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.patch(
            `${api_url}/vente-privee/prospect/${id}/status`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

    listVpProspects(vpId, params = {}) {
        const token = storage.getToken();
        const mgToken = storage.getMgToken();

        return axios.get(
            `${api_url}/vente-privee/${vpId}/prospect`,
            {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                    [mg_token_name]: mgToken
                }
            }
        );
    }

}

export default new VentePriveeService();